<template lang="pug">
.inserir-dados
    .inserir-dados__bloco
        h3.denuncia-inserir__titulo {{ translate('titulo_manual') }}
        .inserir-dados__card
            p.manual__descricao {{ translate('descricao_manual') }}
            .field
                label.field__label {{ translate('label_field_manual') }}
                input.field__input(
                    :placeholder='translate("label_field_manual")',
                    :disabled='!!state.resultado',
                    v-model='data.inputData',
                    v-mask='data.mask',
                    @input='e => updateMask(e.target.value)'
                )
            .inserir-dados__actions
                button.denuncia-inserir__button(
                    :disabled='!!state.resultado',
                    @click='adicionar'
                )
                    i.mdi.mdi-plus.denuncia-inserir__icon
                    span {{ translate('button_manual_adicionar') }}
    .inserir-dados__bloco
        h3.denuncia-inserir__titulo {{ translate('titulo_planilha') }}
        .inserir-dados__card
            div
                p {{ translate('descricao_planilha') }}
                ul.inserir-dados__un-list
                    li {{ translate('label_fields_panilha') }}
            div
                p.inserir-dados__descricao-modelo {{ translate('descricao_modelo_planilha') }}
                .inserir-dados__actions
                    button.denuncia-inserir__button(disabled)
                        i.mdi.mdi-tray-arrow-up.denuncia-inserir__icon
                        span {{ translate('button_planilha_inserir') }}
                    button.denuncia-inserir__button.denuncia-inserir__button--secondary(
                        disabled
                    )
                        i.mdi.mdi-tray-arrow-down.denuncia-inserir__icon
                        span {{ translate('button_planilha_baixar') }}
</template>
<script>
import { defineComponent, reactive } from 'vue';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReportInsert';

export default defineComponent({
    setup() {
        const { state, adicionarItem, translate } = useShareReportInsert();

        const data = reactive({
            inputData: '',
            mask: '###.###.###-##'
        });

        function adicionar() {
            adicionarItem(data.inputData);
            data.inputData = '';
        }

        function updateMask(value) {
            if (isNaN(value[0])) {
                data.mask = 'XX-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
                data.inputData = data.inputData.toUpperCase();
            } else {
                const valueCleaned = value.replace(/\D/g, '');
                if (valueCleaned.length <= 11) {
                    data.mask = '###.###.###-##';
                } else {
                    data.mask = '##.###.###/####-##';
                }
            }
        }

        return {
            state,
            data,
            updateMask,
            adicionarItem,
            adicionar,
            translate
        };
    }
});
</script>

<style lang="scss" scoped>
.denuncia-inserir {
    & .inserir-dados {
        display: flex;
        gap: 16px;
        flex-wrap: wrap;
        &__bloco {
            width: 100%;
            @media only screen and (min-width: 768px) {
                width: calc(50% - 8px);
            }
        }
        &__card {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 280px;
            padding: 20px;
            background-color: $white;
            border-radius: $default-border-radius;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
        &__descricao-modelo {
            margin-bottom: 22px;
        }
        &__un-list {
            color: var(--primary);
            font-weight: bold;
            padding-left: 26px;
            margin: 0;
        }
        &__actions {
            display: flex;
            justify-content: space-between;
            flex-direction: row-reverse;
        }
    }
}
</style>
